import _ from 'lodash';

import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { CustomersState } from './types';

import { Customer } from '@/models';

/**
 * Getters
 *
 * Vuex allows us to define "getters" in the store.
 * - You can think of them as computed properties for stores.
 * - Like computed properties, a getter's result is cached based on its dependencies,
 *   and will only re-evaluate when some of its dependencies have changed.
 */
export const getters: GetterTree<CustomersState, RootState> = {

	/**
	 * Get the current Customer
	 * 
	 * @param { CustomersState } state
	 * @returns Current client
	 */
	 current: (state: CustomersState): Customer|undefined => {
		return state.current;
	},

	/**
	 * Get the list of Customers
	 * 
	 * @param { CustomersState } state
	 * @returns List of customers
	 */
	list: (state: CustomersState): Customer[]|undefined => {
		return state.list;
	},

	/**
   * The updates which have been made since creating/loading/last-saving the current customer
   */
	 hasUnsavedChanges: (state: CustomersState): boolean => state.updates.length > 0,
}